<template>
	<div>
		<div class="match_items">
			<div class="live-table_row">
				<div class="live-table_col __2">
					<div class="live-table_name">Игроки</div>
				</div>
				<div class="live-table_col __3">
					<div class="live-table_name">Голы</div>
				</div>
			</div>
			<div class="match_item">
				<div class="match_item-content">
					<div class="match_item-data active">
						<div class="live-table_content">
							<div class="live-table_data __btn">
								<div class="live-table_row __no-color" v-for="(scorer, index) in data" :key="index">
									<div class="live-table_col __2">
										<div class="live-table_main">
											<div class="live-table_pic">
												<img :src="$hostname + '/img/country/' +  scorer.country_code">
											</div>
											<div class="live-table_name-main __tdn" >{{ scorer.name }}</div>
										</div>
									</div>
									<div class="live-table_col __3">
										<div class="live-table_name-2">
											{{ scorer.goals }}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: ['data']
	}
</script>

<style scoped>

</style>